import { Reducer } from 'redux';
import { UserProfile } from '@chr/online-shared-microsite-core/types';
import { IAppState } from '@/app-state';
import { UserProfileActionTypes } from './actions';
import { Status } from '../constants/enums';
import { IUserProfileAction } from '../constants/userProfile';

export interface IUserProfileState {
  status: Status;
  userProfile: UserProfile;
  isError: boolean;
  error: string;
}

export const initialState: IUserProfileState = {
  status: Status.None,
  userProfile: null,
  isError: false,
  error: '',
};

// Reducer
export const userProfileReducer: Reducer = (state = initialState, action: IUserProfileAction): IUserProfileState => {
  switch (action.type) {
    case UserProfileActionTypes.USER_PROFILE_INIT:
      return {
        ...state,
        status: Status.Loading,
      };
    case UserProfileActionTypes.USER_PROFILE_SET:
      return {
        userProfile: action.payload,
        status: Status.Successful,
        isError: false,
        error: '',
      };
    case UserProfileActionTypes.USER_PROFILE_RETRIEVAL_FAILED:
      return {
        ...state,
        status: Status.Failed,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const getUserProfile = (state: IAppState): UserProfile => state.userProfileState.userProfile;
